/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const KeyboardAndMouseConnected: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_KEYBOARD_MOUSE_CONNECTED',
    system: 'CrimsonNative',
    module: 'ConnectionState',
    method: 'KeyboardAndMouseConnected',
    persistent: false
};

export const Connectionstate = {
KeyboardAndMouseConnected
};
